import SectionLayout from "../components/SectionLayout";

export default function Hero({ navList, setShowHeader }) {
  return (
    <SectionLayout id="hero" index={0} setShowHeader={setShowHeader}>
      <div className=" w-full flex flex-col lg:flex-row bg-no-repeat bg-center hero-section-back sm:py-24 ">
        <h2 className=" sm:text-left text-center text-2xl sm:text-4xl sm:leading-snug md:text-5xl font-Mulish font-black md:leading-snug">
          <div
            className="animate-leftright"
            style={{ animationDuration: "700ms" }}
          >
            <div
              className=" animate-heroharmony"
              style={{ animationDuration: "4s" }}
            >
              Welcome,
            </div>
          </div>
          <div
            className="animate-leftright"
            style={{ animationDuration: "900ms" }}
          >
            <div
              className=" animate-heroharmony"
              style={{ animationDuration: "5s" }}
            >
              I Am <span className="text-color3">Ahmed Azad</span>.
            </div>
          </div>
          <div
            className="animate-leftright"
            style={{ animationDuration: "1000ms" }}
          >
            <div
              className=" animate-heroharmony"
              style={{ animationDuration: "7s" }}
            >
              I do <span className="text-color3">programming</span> and stuff
            </div>
          </div>
          <div
            className="animate-leftright"
            style={{ animationDuration: "1200ms" }}
          >
            <div
              className="animate-heroharmony"
              style={{ animationDuration: "6s" }}
            >
              mostly
              <span className="text-color3"> web </span>
              development.
            </div>
          </div>
        </h2>
        <ul className=" flex-1 flex flex-col shrink md:flex-row items-center md:items-end justify-around text-lg sm:text-2xl mt-10 sm:mt-0 select-none ">
          {navList.map((value, index) => {
            return index === 0 ? null : (
              <a
                key={index}
                href={value.url}
                className=" mt-12 link-hover"
                style={{
                  animationName: "left-right",
                  animationDuration: "1200ms",
                }}
              >
                <li>{value.text}</li>
              </a>
            );
          })}
        </ul>
      </div>
    </SectionLayout>
  );
}
